import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Row } from "react-bootstrap";

import GenericUtils from "../../../../utils/GenericUtils";
import { axiosPostRequest } from "../../../../api/ApiClient";
import { ArrowRightIcon, CheckIcon } from "../../../../components/Icons";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/Information.svg";
import { IWorkflowOvertime } from "../../../../context/interfaces/IWorkflowContext";
import Dialog from "../../../../components/Dialog";
import { OvertimeDeferralFieldsType } from "../../../GestaoFaltas/OvertimeWorkflowDetails";
import DialogMessage from "../../../../components/DialogMessage";
import { DialogConfirm } from "../../../GestaoFaltas/Components/DialogConfirm";
import { StyledDefaultButtonLink } from "../../../../styles/pages/AcademicActivityPlanStyles";
import UploadFileStyles from "../../../../styles/pages/UploadFilesStyles";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import InputLabelTextArea from "../../../../components/InputLabelTextArea";
import { useWorkflow } from "../../../../context/WorkflowContext";
import StatusPill from "../StatusPill/StatusPill";
import { ActionsWrapper } from "../../../../styles/pages/Workflows/OvertimeActions";
import { TypeDialogMessageEnum } from "../../../../model/Enums/TypeDialogMessageEnum";
import { StyledFlexDiv } from "../../../../styles/MainStyles";
import OvertimeModal from "../Modals/OvertimeModal";
import OvertimeModalDetails from "../Modals/OvertimeModalDetails";

type OverTimeActionsProps = {
    workflow: IWorkflowOvertime;
};

const { StyledImportButton, StyledModalTitle } = UploadFileStyles;
const { DefaultButtonLink } = ButtonStyles;

const WORKFLOW_FILTER_STATUS = "AGUARDANDO_APROVACAO";

const OverTimeActions: React.FC<OverTimeActionsProps> = ({ workflow }) => {
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [deferButtonClicked, setDeferButtonClicked] =
        useState<boolean>(false);
    const [
        openOvertimeWorkflowDetailsModal,
        setOpenOvertimeWorkflowDetailsModal,
    ] = useState<boolean>(false);
    const [workflowDetails, setWorkflowDetails] =
        useState<IWorkflowOvertime | null>(null);
    const [workflowToDefer, setWorkflowToDefer] =
        useState<OvertimeDeferralFieldsType>({
            details: "",
            guidanceLetter: false,
            modality: "",
            resultCenter: "",
            school: "",
            justification: "",
            campus: "",
        });
    const [
        workflowDeferralConfirmationModalOpen,
        setWorkflowDeferralConfirmationModalOpen,
    ] = useState<boolean>(false);
    const [showWorkflowSuccessModal, setShowWorkflowSuccessModal] =
        useState<boolean>(false);
    const [isOpenCancelReasonModal, setIsOpenCancelReasonModal] =
        useState<boolean>(false);
    const [isOpenDetailsModal, setIsOpenDetailsModal] =
        useState<boolean>(false);

    const { instance } = useMsal();

    const { workflowFilter, filterWorkflows } = useWorkflow();

    const handleCloseDialogError = () => {
        setErrorMessage("");
    };

    const handleCloseDialogSuccess = () => {
        setShowWorkflowSuccessModal(false);
        filterWorkflows(workflowFilter);
    };

    const handleOpenOvertimeWorkflowDetailsModal = (isDetails: boolean) => {
        setDeferButtonClicked(isDetails);
        setOpenOvertimeWorkflowDetailsModal(true);
        setWorkflowDetails(workflow);
    };

    const handleDeferOvertimeWorkflow = async () => {
        if (!workflowToDefer || !workflowDetails) {
            return;
        }

        const objectSend = {
            id: workflowDetails?.id,
            created: workflowDetails?.created,
            updated: workflowDetails?.updated,
            cartaoAgendaId: workflowDetails?.cartaoAgendaId,
            nomeDocente: workflowDetails?.nomeDocente,
            matriculaAdp: workflowDetails?.matriculaAdp,
            dtCriacaoCartao: workflowDetails?.dtAlocacaoCartao,
            dtAlocacaoCartao: workflowDetails?.dtAlocacaoCartao,
            nomeAtividade: workflowDetails?.nomeAtividade,
            horaInicio: workflowDetails?.horaInicio,
            horaFim: workflowDetails.horaFim,
            status: "APROVADO",
            cartaOrientacao: workflowToDefer.guidanceLetter,
            campus: workflowToDefer.campus,
            escola: workflowToDefer.school,
            centroResultado: {
                id: Number(workflowToDefer.resultCenter),
            },
            modalidade: {
                modalidadeId: workflowToDefer.modality,
            },
            detalhe: workflowToDefer.details,
            justificativa: workflowToDefer.justification || "",
        };

        const uri = `/docente/v1/workflows/${workflowFilter.workflowTypeId}/processos`;

        const response = await axiosPostRequest(
            uri,
            objectSend,
            GenericUtils.getAccessTokenDocente(),
            instance
        );

        if (response.status >= 200 && response.status < 300) {
            setWorkflowDeferralConfirmationModalOpen(false);
            setShowWorkflowSuccessModal(true);
        } else {
            setErrorMessage(response.data?.details);
        }
    };

    const handleClose = () => {
        setOpenOvertimeWorkflowDetailsModal(false);
        setWorkflowDeferralConfirmationModalOpen(false);
    };

    const handleCloseDeferralModal = () => {
        setWorkflowDeferralConfirmationModalOpen(false);
        setOpenOvertimeWorkflowDetailsModal(true);
    };

    const workflowDeferralConfirmationModal = (
        <Dialog
            openModal={workflowDeferralConfirmationModalOpen}
            onHide={handleClose}
        >
            <StyledModalTitle>Deseja concluir o processo?</StyledModalTitle>
            {GenericUtils.getUser().isDac && (
                <>
                    <p>Insira abaixo a justificativa.</p>
                    <span
                        style={{
                            fontSize: 12,
                            color: "#787878",
                            textAlign: "left",
                            display: "block",
                        }}
                    >
                        Justificativa
                    </span>
                    <InputLabelTextArea
                        value={workflowToDefer.justification || ""}
                        placeholder="Insira sua justificativa"
                        onChange={(event: any) => {
                            if (workflowToDefer) {
                                setWorkflowToDefer({
                                    ...workflowToDefer,
                                    justification: event.target.value || "",
                                });
                            }
                        }}
                        viewLengthInfo
                        maxLength={500}
                        style={{
                            height: "107px",
                            borderStyle: "solid",
                            borderColor: "#787878",
                            width: "100%",
                        }}
                    />
                </>
            )}
            <Row style={{ justifyContent: "center" }}>
                <StyledImportButton
                    style={{ width: 126, marginTop: 24 }}
                    onClick={() => {
                        handleDeferOvertimeWorkflow();
                    }}
                    disabled={
                        GenericUtils.getUser().isDac &&
                        !workflowToDefer.justification
                    }
                >
                    Concluir
                </StyledImportButton>
            </Row>
            <div style={{ height: 15 }} />
            <Row style={{ justifyContent: "center" }}>
                <DefaultButtonLink
                    onClick={() => {
                        handleCloseDeferralModal();
                    }}
                >
                    Cancelar
                </DefaultButtonLink>
            </Row>
        </Dialog>
    );

    const handleOvertimeWorkflowDeferral = (
        overtimeDeferralFields: OvertimeDeferralFieldsType
    ) => {
        setWorkflowToDefer(overtimeDeferralFields);
        setOpenOvertimeWorkflowDetailsModal(false);
        setWorkflowDeferralConfirmationModalOpen(true);
    };

    const handleStatusLabel = () => {
        if (workflow.status === "APROVADO") return "Visualizar Informações";

        return "Motivo Cancelamento";
    };

    const handleCloseCancelReason = () => {
        setIsOpenCancelReasonModal(false);
    };

    const handleCloseDetailsModal = () => {
        setIsOpenDetailsModal(false);
    };

    const handleOpenConcludedModal = (status: string) => {
        if (status === "APROVADO") {
            setIsOpenDetailsModal(true);
        } else {
            setIsOpenCancelReasonModal(true);
        }
    };

    const overtimeModal = openOvertimeWorkflowDetailsModal && (
        <OvertimeModal
            open={openOvertimeWorkflowDetailsModal}
            workflow={workflowDetails}
            onClose={() => {
                setOpenOvertimeWorkflowDetailsModal(false);
            }}
            onDeferir={handleOvertimeWorkflowDeferral}
            hasToShowFormFields={deferButtonClicked}
        />
    );

    const DialogError = Boolean(errorMessage) && (
        <DialogMessage
            type="error"
            show={Boolean(errorMessage)}
            title={errorMessage}
            onClose={handleCloseDialogError}
        />
    );

    const DialogCancelReason = isOpenCancelReasonModal && (
        <DialogMessage
            type={TypeDialogMessageEnum.Info}
            show={isOpenCancelReasonModal}
            title="Motivo do Cancelamento"
            text={`Justificativa: ${workflow?.justificativa}`}
            showPrimaryButton={false}
            textButtonClose="Fechar"
            onClose={handleCloseCancelReason}
        />
    );

    const DialogDetails = isOpenDetailsModal && (
        <OvertimeModalDetails
            open={isOpenDetailsModal}
            workflow={workflow}
            onClose={handleCloseDetailsModal}
        />
    );

    const workflowSuccess = showWorkflowSuccessModal && (
        <DialogConfirm
            openModal={showWorkflowSuccessModal}
            handleClose={handleCloseDialogSuccess}
            modalTitle="Processo concluído"
            acceptButtonText="Ok"
        />
    );

    return (
        <>
            <StyledFlexDiv>
                {workflow.status === WORKFLOW_FILTER_STATUS ? (
                    <>
                        <StyledDefaultButtonLink
                            variant="link"
                            onClick={() => {
                                handleOpenOvertimeWorkflowDetailsModal(false);
                            }}
                        >
                            <ArrowRightIcon style={{ fill: "#8A0538" }} />
                            Ver detalhes
                        </StyledDefaultButtonLink>
                        <StyledDefaultButtonLink
                            variant="link"
                            onClick={() => {
                                handleOpenOvertimeWorkflowDetailsModal(true);
                            }}
                        >
                            <CheckIcon style={{ fill: "#8A0538" }} />
                            Concluir processo
                        </StyledDefaultButtonLink>
                    </>
                ) : (
                    <ActionsWrapper>
                        <StatusPill
                            status={workflow.status}
                            key={workflow.id}
                        />
                        <StyledDefaultButtonLink
                            variant="link"
                            onClick={() =>
                                handleOpenConcludedModal(workflow.status)
                            }
                        >
                            <InfoIcon style={{ fill: "#8A0538" }} />
                            {handleStatusLabel()}
                        </StyledDefaultButtonLink>
                    </ActionsWrapper>
                )}
            </StyledFlexDiv>
            {workflowDeferralConfirmationModal}
            {DialogError}
            {DialogCancelReason}
            {DialogDetails}
            {overtimeModal}
            {workflowSuccess}
        </>
    );
};

export default OverTimeActions;
